const root = document.getElementById('root')
const data = JSON.parse(root.getAttribute('data-json'))
const homeData = JSON.parse(root.getAttribute('data-home'))
const headerData = JSON.parse(root.getAttribute('data-header'))
root.removeAttribute('data-json')
root.removeAttribute('data-home')
root.removeAttribute('data-header')

export { root, data, homeData, headerData }
